import { useFeatureFlagEnabled } from "posthog-js/react";

export const useIsWorkflowTrackerEnabled = () => useFeatureFlagEnabled("enable_new_onboarding_setup_flow") ?? false;
